"use strict";

exports.__esModule = true;
exports.default = void 0;

var _roundTo = _interopRequireDefault(require("../../../../utils/roundTo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var roundOnBlur = function roundOnBlur(_ref) {
  var onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      step = _ref.step,
      allowNegative = _ref.allowNegative;
  return function (e) {
    var original = +e.target.value;
    var rounded = (0, _roundTo.default)(step, allowNegative)(e.target.value);
    var max = +e.target.getAttribute('max');
    var min = +e.target.getAttribute('min');

    if (original > max) {
      e.target.value = max;
    } else if (original < min) {
      e.target.value = min;
    } else if (rounded !== original) {
      e.target.value = rounded;
    }

    if (original !== +e.target.value) {
      onChange(e, function () {
        onBlur(e);
      });
    } else {
      onBlur(e);
    }
  };
};

var _default = roundOnBlur;
exports.default = _default;